import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnalyseData = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 55,
	height: 54,
	viewBox: "0 0 55 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1248_21437)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M22 14.6396H14V43.6396H22V14.6396Z",
				fill: "#F7DD97"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5 0.639648V53.6396",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M55 47.6396H0",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 14.6396H6",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 25.6396H6",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 36.6396H6",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17 52.6396V48.6396",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28 52.6396V48.6396",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M39 52.6396V48.6396",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46 26.6396H39V40.6396H46V26.6396Z",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33 19.6396H26V40.6396H33V19.6396Z",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19 11.6396H12V40.6396H19V11.6396Z",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1248_21437",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 55,
			height: 53,
			fill: "white",
			transform: "translate(0 0.639648)"
		})
	}) })]
});
export default SvgAnalyseData;
